import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell, CartesianGrid } from "recharts";

const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const tooltipStyle = {
  contentStyle: { background: "#0d0d0d", border: "1px solid #00ff9033", borderRadius: 8, fontSize: 11 },
  labelStyle: { color: "#00ff90" },
};

function complianceColor(pct) {
  if (pct >= 95) return "#00ff90";
  if (pct >= 85) return "#60a5fa";
  if (pct >= 70) return "#fbbf24";
  return "#f87171";
}

export default function ComplianceOverview({ loading, rows }) {
  if (loading) return (
    <div className={`${card} p-5`}>
      <div className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium mb-4">Compliance Overview</div>
      <div className="h-48 rounded-lg bg-white/5 animate-pulse" />
    </div>
  );

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5 flex items-center justify-between">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Compliance Overview</span>
        {rows.length > 0 && (
          <span className="text-xs text-white/30">
            Avg: {Math.round(rows.reduce((s, r) => s + r.compliance, 0) / rows.length)}%
          </span>
        )}
      </div>
      <div className="p-5 space-y-5">
        {rows.length === 0 ? (
          <p className="text-white/20 text-sm italic text-center py-4">No data for selected filters.</p>
        ) : (
          <>
            {/* Bar chart */}
            <ResponsiveContainer width="100%" height={120}>
              <BarChart data={rows} margin={{ top: 4, right: 4, left: -28, bottom: 0 }}>
                <CartesianGrid stroke="rgba(255,255,255,0.04)" />
                <XAxis dataKey="dept" tick={{ fontSize: 9, fill: "rgba(255,255,255,0.35)" }} />
                <YAxis domain={[0, 100]} tick={{ fontSize: 9, fill: "rgba(255,255,255,0.25)" }} unit="%" />
                <Tooltip {...tooltipStyle} formatter={v => [`${v}%`, "Compliance"]} />
                <Bar dataKey="compliance" radius={[4, 4, 0, 0]}>
                  {rows.map((r, i) => <Cell key={i} fill={complianceColor(r.compliance)} fillOpacity={0.8} />)}
                </Bar>
              </BarChart>
            </ResponsiveContainer>

            {/* Progress rows */}
            <div className="space-y-2.5">
              {rows.map((r, i) => {
                const color = complianceColor(r.compliance);
                return (
                  <div key={i}>
                    <div className="flex items-center justify-between mb-1">
                      <div className="flex items-center gap-2">
                        <span className="text-xs text-white/60">{r.dept}</span>
                        {r.location && <span className="text-xs text-white/25">· {r.location}</span>}
                      </div>
                      <span className="text-xs font-bold" style={{ color }}>{r.compliance}%</span>
                    </div>
                    <div className="h-1.5 rounded-full bg-white/5">
                      <div className="h-full rounded-full transition-all" style={{ width: `${r.compliance}%`, background: color }} />
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}